import { APIURL } from "../config/api";
import axios from "axios";

export interface ILoginLinkRequest {
  email: string;
  originUrl: string;
}

export const sendLoginLink = async (data: ILoginLinkRequest): Promise<any> => {
  const response = await axios.post(`${APIURL}/auth/loginlink`, {
    ...data,
  });
  return response.data;
};

export interface IClaimAnonymousClientRequest {
  /** ID token of the newly created full account - sent as the Authorization header, matching
   *  every other client endpoint's auth pattern. */
  newUserIdToken: string;
  /** ID token of the anonymous session being upgraded, captured before it was replaced. */
  anonymousIdToken: string;
}

/**
 * Re-parents the CRM client record tied to an anonymous Firebase session onto a newly created
 * full account, by UID. Both tokens are verified server-side - nothing here is trusted from the
 * client beyond the tokens themselves.
 */
export const claimAnonymousClient = async (
  data: IClaimAnonymousClientRequest
): Promise<any> => {
  const response = await axios.post(
    `${APIURL}/client/claim-anonymous`,
    { anonymousIdToken: data.anonymousIdToken },
    {
      headers: {
        Authorization: data.newUserIdToken,
      },
    }
  );
  return response.data;
};
